import { css3, html5, javascript, mongodb, nextjs, nodejs, p5, react, sass, tailwindcss, typescript } from "./icons/technologies";
import weatherApp from './images/weather-app.png';
import hildamemorycard from './images/hilda-memory-card.png';
import laboratoriodivinojesus from './images/laboratorio-divino-jesus.png';
import cvapplication from './images/cv-application.png';
import noiseflowfieldpainter from './images/noise-flow-field-painter.png';
import flowfield from './images/flow-field.png';
import raingenerator from './images/rain-generator.png';

import memomateNotetaker from './images/memomate-notetaker.png';

import gameShop from './images/game-shop.png';
import ETCHASKETCH from './images/ETCH-A-SKETCH.png';
import TICTACTOE from './images/TIC-TAC-TOE.png';
import minimessageboard from './images/mini-message-board.png';
import pixelai from './images/pixelai.png';

export const projects = [
    {
        name: 'PixelAI',
        description: 'PixelAI es una aplicación que utiliza inteligencia artificial para generar imágenes a partir de texto.',
        img: pixelai,
        urllive: 'https://pixelai-zevaguillo.vercel.app/',
        urlrepo: 'https://github.com/ZevaGuillo/AI-image-generation',
        technologies: [react, typescript, tailwindcss, nodejs, mongodb]
    },
    {
        name: 'MemoMate Notetaker',
        description: 'Una aplicación para una fácil gestión de notas y temas. Utilizando T3 stack',
        img: memomateNotetaker,
        urllive: 'https://memomate-note.vercel.app/',
        urlrepo: 'https://github.com/ZevaGuillo/memomate-notetaker',
        technologies: [ nextjs, typescript, tailwindcss]
    },
    {
        name: 'Nimbus Weather App',
        description: 'Es una aplicación web que proporciona información meteorológica para cualquier lugar del mundo.',
        img: weatherApp,
        urllive: 'https://nimbus-weather-app.vercel.app/',
        urlrepo: 'https://github.com/ZevaGuillo/nimbus-weather-app',
        technologies: [ nextjs, typescript, tailwindcss]
    },
    {
        name: 'Game Shop',
        description: 'El proyecto es un e-commerce de videojuegos que utiliza Sanity para el CMS y Firebase para autenticación y almacenamiento de datos.',
        img: gameShop,
        urllive: 'https://game-shop-pink.vercel.app/',
        urlrepo: 'https://github.com/ZevaGuillo/game-shop',
        technologies: [ react, typescript]
    },
    {
        name: 'Laboratorio Divino Jesus',
        description: 'Sitio web para el laboratorio clínico Divino Jesús.',
        img: laboratoriodivinojesus,
        urllive: 'https://www.laboratoriodivinojesus.com/',
        urlrepo: 'https://react-laboratorio.vercel.app/',
        technologies: [react,sass]
    },
    {
        name: 'Hilda Memory Game',
        description: 'Juego Memory card utilizando personajes de la serie de Hilda.',
        img: hildamemorycard,
        urllive: 'https://hilda-memory-card.vercel.app/',
        urlrepo: 'https://github.com/ZevaGuillo/hilda-memory-card',
        technologies: [react,sass]
    },
    {
        name: 'Mini Message Board',
        description: 'Los usuarios pueden publicar mensajes y ver una lista de todos los mensajes que se han publicado.',
        img: minimessageboard,
        urllive: 'https://mini-message-frontend.vercel.app/',
        urlrepo: 'https://github.com/ZevaGuillo/mini-message-board',
        technologies: [react,typescript, nodejs, mongodb]
    },

    {
        name: 'CV Application',
        description: 'Aplicación para crear un curriculum.',
        img: cvapplication,
        urllive: 'https://cv-application-zevaguillo.vercel.app/',
        urlrepo: 'https://github.com/ZevaGuillo/cv-application',
        technologies: [react,css3]
    },
    {
        name: 'Noise Flow Field Painter',
        description: 'Aplicación basada en el proyecto de Jason Labbe, que permite variar longitud y orientación de las partículas. ',
        img: noiseflowfieldpainter,
        urllive: 'https://zevaguillo.github.io/noise-flow-field-painter/',
        urlrepo: 'https://github.com/ZevaGuillo/noise-flow-field-painter',
        technologies: [html5,css3,p5, javascript]
    },
    {
        name: 'Flow Field',
        description: 'Generador de Flow Field que permite variar sus parámetros.',
        img: flowfield,
        urllive: 'https://zevaguillo.github.io/Flow-Field/',
        urlrepo: 'https://github.com/ZevaGuillo/Flow-Field',
        technologies: [html5,css3,p5, javascript]
    },
    {
        name: 'Rain Generator',
        description: 'Generador de lluvia que permite variar sus parámetros.',
        img: raingenerator,
        urllive: 'https://github.com/ZevaGuillo/Rain-generator',
        urlrepo: 'https://zevaguillo.github.io/Rain-generator/',
        technologies: [html5,css3,p5, javascript]
    },
    // {
    //     name: 'Time Tracking Dashboard',
    //     description: 'Proyecto basado en Frontend Mentor.',
    //     img: timetrackingdashboard,
    //     urllive: 'https://zevaguillo.github.io/Time-tracking-dashboard/',
    //     urlrepo: 'https://github.com/ZevaGuillo/Time-tracking-dashboard',
    //     technologies: [react,css3]
    // },
    // {
    //     name: 'Advice Generator',
    //     description: 'Proyecto basado en Frontend Mentor.',
    //     img: advicegenerato,
    //     urllive: 'https://advice-generator-zevaguillo.vercel.app/',
    //     urlrepo: 'https://github.com/ZevaGuillo/advice-generator',
    //     technologies: [react,css3]
    // },
    // {
    //     name: 'Interactive Rating Component',
    //     description: 'Proyecto basado en Frontend Mentor.',
    //     img: interactiveratingcomponent,
    //     urllive: 'https://zevaguillo.github.io/Interactive-rating-component/',
    //     urlrepo: 'https://github.com/ZevaGuillo/Interactive-rating-component',
    //     technologies: [react,tailwindcss]
    // },
    {
        name: 'ETCH A SKETCH',
        description: 'Permite crear tu propio pixel art.',
        img: ETCHASKETCH,
        urllive: 'https://zevaguillo.github.io/ETCH-A-SKETCH/',
        urlrepo: 'https://github.com/ZevaGuillo/ETCH-A-SKETCH',
        technologies: [html5,css3, javascript]
    },
    // {
    //     name: 'To-do List',
    //     description: '',
    //     img: todolist,
    //     urllive: 'https://zevaguillo.github.io/Todo-List/',
    //     urlrepo: 'https://github.com/ZevaGuillo/Todo-List',
    //     technologies: [html5,css3]
    // },
    {
        name: 'TIC-TAC-TOE',
        description: '',
        img: TICTACTOE,
        urllive: 'https://zevaguillo.github.io/TIC-TAC-TOE/',
        urlrepo: 'https://github.com/ZevaGuillo/TIC-TAC-TOE',
        technologies: [html5,css3, javascript]
    },
]